import {useEffect} from 'react';
import useStore from './use-store';

const useGroups = () => {
    const {store} = useStore();

    useEffect(() => {
        store.group.loadGroups();
    }, []);

    return {groupStore: store.group};
};

export default useGroups;
